import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { getUOM, updateUOM } from "../../../apis/uom";
import { toastify } from "../../../helperFunctions/toastify";
import { customStringSort } from "../../../helperFunctions/utils";
import DeleteModal from "../../SharedComponents/DeleteModal";
import FilterComponent from "../../SharedComponents/FilterComponent";

export default function UomInventory() {
	const navigate = useNavigate();
	const [uoms, setUoms] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [show, setShow] = useState(false);
	const [deleting, setDeleting] = useState("");

	const handleClose = () => {
		setShow(false);
		setDeleting("");
	};

	const getUomList = async () => {
		const response = await getUOM();
		if (response?.status !== "Fail") {
			setUoms(response.reverse());
		} else {
			if (response?.message === "No data Found") {
				setUoms([]);
			} else {
				toastify(response?.message, "error");
			}
		}
	};

	const removeUom = async () => {
		setShow(false);
		let response = await updateUOM(deleting, { isDeleted: true });
		if (response?.status !== "Fail") {
			getUomList();
			toastify("UOM deleted successfully!", "success");
		} else {
			toastify(response?.message, "error");
		}
	};

	const editUom = (e) => {
		navigate("/add-uom-inventory", {
			state: {
				uom: e,
			},
		});
	};

	const addUom = () => {
		navigate("/add-uom-inventory");
	};

	useEffect(() => {
		getUomList();
	}, []);

	const columns = [
		{
			name: (
				<div className="d-flex align-items-center" id="ovly16">
					<span className="me-2">Name</span>
					{
						<FilterComponent
							type="search"
							array={uoms}
							setArray={setFilteredData}
							value="Name"
						/>
					}
				</div>
			),
			selector: (row) => row.name,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "name"),
		},
		{
			name: "Description",
			selector: (row) => row.description,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "description"),
		},
		{
			name: "Action",
			selector: (row) => row.action,
		},
	];

	const data = (filteredData.length === 0 ? uoms : filteredData)?.map(
		(e, index) => {
			return {
				id: e._id,
				name: e.name,
				index: index,
				description: e.description,
				action: (
					<div className="d-flex">
						<div
							className="mx-3  cursor-pointer icon-width"
							onClick={() => {
								editUom(e);
							}}
						>
							<i className="fa fa-pen"></i>
						</div>
						<div
							className="mx-3  cursor-pointer icon-width"
							onClick={() => {
								setDeleting(e._id);
								setShow(true);
							}}
						>
							<i className="fa fa-trash"></i>
						</div>
					</div>
				),
			};
		},
	);

	const customStyles = {
		headCells: {
			style: {
				justifyContent: "center",
			},
		},
		cells: {
			style: {
				justifyContent: "center",
				textAlign: "center",
			},
		},
	};

	const conditionalRowStyles = [
		{
			when: (row) => row,
			style: {
				borderWidth: "0px",
			},
		},
		{
			when: (row) => row.index % 2 === 1,
			style: {
				borderWidth: "0px",
				backgroundColor: "#f8f8f8",
			},
		},
	];

	return (
		<>
			<div className="container p-0">
				<div className="mainHeading px-4">
					<h1>UOM Inventory</h1>
					<Button className="addItem" onClick={addUom}>
						+ Add New
					</Button>
				</div>

				<DeleteModal
					content="Confirm UOM Deletion?"
					onYes={removeUom}
					onNo={handleClose}
					show={show}
				/>

				<DataTable
					columns={columns}
					customStyles={customStyles}
					data={data || []}
					pagination
					conditionalRowStyles={conditionalRowStyles}
				/>
			</div>
		</>
	);
}
